import BaseRepository from "@/services/resources/repository";
import byTheme from "@/services/resources/mixins/query-by-theme";

class Repository extends BaseRepository {
    static make(model, schema) {
        return new Repository(model, schema).$mix(byTheme);
    }
}

export default Repository;
